import React from 'react';
import HospitalListTable from './HospitalListTable';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import { hospitalListFetch, hospitalListSetPage } from '../../lib/redux/actions/hospitals';
import Alert from 'react-bootstrap/Alert';
import Paginator from '../../components/common/Paginator';
import * as ROUTES from '../../lib/routing/frontend';
import MASpinner from '../../components/common/MASpinner';
import { Link } from 'react-router-dom';
import { isSeniorStaff } from '../../lib/helper/authorisation';

const mapStateToProps = (state) => ({
  ...state.hospitals,
});

const mapDispatchToProps = {
  hospitalListFetch,
  hospitalListSetPage,
};

class HospitalListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
      filterText: '',
    };
  }

  getCombinedFilters() {
    const { filters, defaultFilters = {} } = this.props;
    return { ...filters, ...defaultFilters, pagination: false };
  }

  componentDidMount() {
    this.props.hospitalListFetch(this.getQueryParamPage(), this.getCombinedFilters());
  }

  componentDidUpdate(prevProps) {
    const { currentPage, hospitalListFetch, hospitalListSetPage, filters } = this.props;

    if (prevProps.match.params.page !== this.getQueryParamPage()) {
      hospitalListSetPage(this.getQueryParamPage());
    }
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters) {
      hospitalListFetch(currentPage, this.getCombinedFilters());
    }
  }

  getQueryParamPage() {
    return Number(this.props.match.params.page) || 1;
  }

  changePage(page) {
    const { history, hospitalListSetPage } = this.props;
    hospitalListSetPage(page);
    history.push(ROUTES.HOSPITALS.ALL.replace(':page', page));
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    const newPage = Math.min(currentPage + 1, pageCount);
    this.changePage(newPage);
  }

  prevPage() {
    const { currentPage } = this.props;
    const newPage = Math.max(currentPage - 1, 1);
    this.changePage(newPage);
  }

  render() {
    const { hospitals: allHospitals, isFetchingHospitals, currentPage, pageCount, pageTitle } = this.props;

    let hospitals = allHospitals.filter((hospital) => {
      return hospital.name.toLowerCase().includes(this.state.filterText);
      //      const matchesTreatmentSetting = !this.state.treatmentSettingsOnly || hospital.isTreatmentSetting;
      //      return matchesText;
    });

    return (
      <div>
        <Card>
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
              <div>{pageTitle}</div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="position-relative mr-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name"
                    value={this.state.filterText}
                    onChange={(e) => this.setState({ filterText: e.target.value.toLowerCase() })}
                  />
                  {this.state.filterText && (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => this.setState({ filterText: '' })}
                      style={{
                        position: 'absolute',
                        right: '0',
                        top: '0',
                        bottom: '0',
                        border: 'none',
                        background: 'none',
                        padding: '0 10px',
                      }}>
                      <i className="fa fa-times" />
                    </button>
                  )}
                </div>
                {!isFetchingHospitals && hospitals && hospitals.length > 0 && (
                  <span className="ml-2 tabular-data-result-count">{hospitals.length} hospitals</span>
                )}
              </div>
            </div>
          </Card.Header>

          {isFetchingHospitals && (
            <Card.Body>
              <MASpinner />
            </Card.Body>
          )}

          {!isFetchingHospitals && (hospitals === null || hospitals.length === 0) && (
            <Card.Body>
              <Alert variant={'info'} className="mb-0">
                <i className="fas fa-info-circle" /> No hospitals found
                {isSeniorStaff() && (
                  <div className="mt-2">
                    <Link to={ROUTES.HOSPITALS.CREATE} className="btn btn-primary btn-sm">
                      <i className="fas fa-plus"></i> Add First Hospital
                    </Link>
                  </div>
                )}
              </Alert>
            </Card.Body>
          )}

          {!isFetchingHospitals && hospitals && hospitals.length > 0 && <HospitalListTable hospitals={hospitals} />}

          {!isFetchingHospitals && hospitals && hospitals.length > 0 && (
            <Paginator
              currentPage={currentPage}
              pageCount={pageCount}
              setPage={this.changePage.bind(this)}
              nextPage={this.nextPage.bind(this)}
              prevPage={this.prevPage.bind(this)}
            />
          )}
        </Card>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HospitalListContainer);
